import type { AnalyticsSnapshot, ContentCode } from './types.js';

export type WorkspaceHomeState = 'first-use' | 'incomplete-loop' | 'daily-workspace';

export function workspaceMetric(analytics: AnalyticsSnapshot, metric: 'scans' | 'submissions'): number {
  return analytics.realtime.find((item) => item.resourceType === 'workspace' && item.metric === metric)?.total ?? 0;
}

export function workspaceHomeState(codes: ContentCode[], analytics: AnalyticsSnapshot): WorkspaceHomeState {
  if (workspaceMetric(analytics, 'submissions') > 0) return 'daily-workspace';
  return codes.length > 0 ? 'incomplete-loop' : 'first-use';
}

export function liveHostedCode(codes: ContentCode[]): ContentCode | null {
  return codes.find((code) => code.kind === 'hosted'
    && code.status === 'active'
    && Boolean(code.page?.currentRevisionId)
    && Boolean(code.attachedForm)) ?? null;
}
